import { ActivityDate } from "@/app/activity/activity-time"
import { formatDate } from "@/app/utils/format-date"
import { DropStatus } from "@anaconda/core/drop/types"
import { Trans } from "@lingui/react/macro"

export type DropStatusData = {
  endDate: string | null
  startDate: string
  status: DropStatus
  isLimitedEdition: boolean
  lastActivityTime: string | null
}

export function DropStatusDate({
  data,
}: {
  data: DropStatusData
}) {
  const { endDate, startDate, status, isLimitedEdition, lastActivityTime } =
    data

  if (status === DropStatus.Upcoming) {
    return (
      <>
        <Trans>Starts on</Trans>{" "}
        <span title={formatDate(new Date(startDate))}>
          {formatDate(new Date(startDate))}
        </span>
      </>
    )
  }

  if (status === DropStatus.Ended && isLimitedEdition && lastActivityTime) {
    return (
      <>
        <Trans>Ended</Trans>{" "}
        <span title={formatDate(new Date(lastActivityTime))}>
          <ActivityDate date={new Date(lastActivityTime)} />
        </span>
      </>
    )
  }

  if (!endDate) {
    return <Trans>Mint Open</Trans>
  }

  if (status === DropStatus.Minting) {
    return (
      <>
        <Trans>Ends on</Trans>{" "}
        <span title={formatDate(new Date(endDate))}>
          {formatDate(new Date(endDate))}
        </span>
      </>
    )
  }

  return (
    <>
      <Trans>Ended</Trans>{" "}
      <span title={formatDate(new Date(endDate))}>
        <ActivityDate date={new Date(endDate)} />
      </span>
    </>
  )
}
